import { colors, strings } from "asset/constant";
import { useAboutUs } from "client/api";
import { Error, Header, ListContainer, Loading } from "component";
import Text from "component/typography/Text";
import React from "react";
import { Platform } from "react-native";
import WebView from "react-native-webview";
import { mq } from "utils";

export default function AboutUs() {
  const { data, isLoading, isError, error, refetch } = useAboutUs();

  const _renderContent = () => {
    if (isLoading) {
      return <Loading />;
    }

    if (isError) {
      return <Error reset={refetch} error={error} />;
    }

    return Platform.OS === "web" ? (
      <iframe
        style={{ borderWidth: 0 }}
        srcDoc={data?.data.data}
        height={"100%"}
      />
    ) : (
      <WebView
        javaScriptEnabled
        scrollEnabled={false}
        automaticallyAdjustContentInsets={false}
        containerStyle={{
          padding: mq(10),
          backgroundColor: colors.white,
          fontSize: mq(15),
        }}
        style={{ fontSize: mq(15) }}
        source={{ html: data?.data.data }}
      />
    );
  };

  return (
    <>
      <>
        <Header title={strings.about_us} />
        <ListContainer>
          {_renderContent()}
          <Text>...</Text>
        </ListContainer>
      </>
    </>
  );
}
